import { onLCP, onCLS, onINP, onFCP, onTTFB } from 'web-vitals';

let vueInstance = null;
let metricsQueue = [];
let isPageReady = false;
let currentPageNameEn = null;

function buildEventData(metric) {
  const connection = navigator.connection;

  return {
    value: metric.value,
    rating: metric.rating,
    'event category': 'Web Vitals',
    page: window.location.pathname,
    'page Url': window.location.href,
    'page title': currentPageNameEn,
    source: 'pov',
    navigationType: metric.navigationType,
    'user agent': navigator.userAgent,
    'connection type': connection?.effectiveType || 'unknown',
    'connection downlink': connection?.downlink || null,
    'connection rtt': connection?.rtt || null,
  };
}

function sendMetricNow(metric, eventData) {
  if (vueInstance?.$track) {
    vueInstance.$track(metric.name, eventData);
  } else {
    console.warn('POV - webVitals - $track not available, cannot send metric');
  }
}

function queueMetric(metric) {
  metricsQueue.push(metric);
}

function flushQueue() {
  metricsQueue.forEach((metric) => {
    const eventData = buildEventData(metric);
    sendMetricNow(metric, eventData);
  });
  metricsQueue = [];
}

function handleMetric(metric) {
  if (!isPageReady) {
    queueMetric(metric);
    return;
  }

  const eventData = buildEventData(metric);
  sendMetricNow(metric, eventData);
}

export function markWebVitalsReady(pageNameEn) {
  if (isPageReady) return;
  isPageReady = true;
  currentPageNameEn = pageNameEn;
  flushQueue();
}

export function resetWebVitalsReady() {
  isPageReady = false;
  currentPageNameEn = null;
}

export function initWebVitals(app) {
  vueInstance = app;
  onLCP(handleMetric);
  onCLS(handleMetric);
  onINP(handleMetric);
  onFCP(handleMetric);
  onTTFB(handleMetric);
}

export default {
  initWebVitals,
  markWebVitalsReady,
  resetWebVitalsReady,
};
